import React, { useState, useEffect } from "react";
import { Slider, Rail, Handles, Tracks, Ticks } from "react-compound-slider";
import { Track, Handle, Tick, sliderStyle, railStyle } from "./SliderUtil";
const tickStyle = {
  position: "absolute",
  marginTop: 14,
  marginLeft: -0.5,
  width: 1,
  height: 5,
  backgroundColor: "silver",
  pointerEvents: "none",
};
const SliderRangeDual = (props) => {
  const [sliderVal, setSliderVal] = useState([props.max, props.min]);

  const handleSliderChange = (e) => {
    props.filter(e);
    setSliderVal(e);
  };

  useEffect(() => {
    // setSliderVal([20, 0])
    setSliderVal([props.max, props.min]);
  }, [props.max, props.min]);

  return (
    <form action="">
      <div className="form-group">
        {props.title !== undefined ? (
          <div
            style={{
              fontSize: 14,
              fontWeight: 700,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <span>{props.min}</span>
            <span>{[props.title]}</span>
            <span>{props.max}</span>
          </div>
        ) : null}
        <div className="sliderRange-dual">
          <Slider
            rootStyle={sliderStyle}
            domain={[props.min, props.max]}
            step={1}
            values={sliderVal}
            // reversed
            onChange={handleSliderChange}
          >
            <Rail>{({ getRailProps }) => <div style={railStyle} {...getRailProps()} />}</Rail>
            <Handles>
              {({ handles, getHandleProps }) => (
                <div className="slider-handles">
                  {handles.map((handle) => (
                    <Handle key={handle.id} handle={handle} getHandleProps={getHandleProps} />
                  ))}
                </div>
              )}
            </Handles>
            <Ticks count={5}>
              {({ ticks }) => (
                <div className="slider-ticks">
                  {ticks.map((tick) => (
                    <div
                      key={tick.id}
                      style={{
                        ...tickStyle,
                        left: `${tick.percent}%`,
                      }}
                    >
                      <p
                        style={{
                          paddingTop: " 0.4rem",
                          // fontSize: "0.8rem",
                          position: "absolute",
                          width: "1.6rem",
                          left: "-0.75rem",
                          textAlign: "center",
                        }}
                      >
                        {tick.value > 0 ? "+" : ""}
                        {tick.value}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </Ticks>
            {/* <Tracks left={false} right={false}>
              {({ tracks, getTrackProps }) => (
                <div className='slider-tracks'>
                  {tracks.map(({ id, source, target }) => (
                    <Track key={id} source={source} target={target} getTrackProps={getTrackProps} />
                  ))}
                </div>
              )}
            </Tracks> */}
          </Slider>
        </div>
      </div>
    </form>
  );
};

export default SliderRangeDual;
